<template>
  <footer
    class="app-footer fixed right-0 bottom-0 py-0 text-center text-base-content border-t border-gray-200 bg-card-bg z-50 break-words flex flex-col"
    :style="{
      'word-break': 'break-word',
      'white-space': 'normal'
    }"
  >
    <div
      v-if="footerFields?.length"
      class="flex justify-center gap-8 w-full py-2 px-4 border-gray-200 bg-selection"
    >
      <a
        v-for="(field, idx) in footerFields"
        :key="idx"
        class="text-white-text cursor-pointer rounded-lg px-2 inline-block"
        :href="`/footer-content/${field.field_id}`"
        target="_blank"
      >
        {{ field.field_label }}
      </a>
    </div>
    <div
      v-if="footerText"
      class="py-1 px-4 text-black"
      id="footer-text"
      v-html="linkifyFooterText"
    />
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  props: {
    footerText: {
      type: String,
      default: "",
    },
    footerFields: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    linkifyFooterText() {
      if (!this.footerText) return '';
      
      let content = this.footerText;
      
      // Convert standalone URLs to clickable links (avoid URLs already in anchor tags)
      const urlRegex = /(?<!href=")(https?:\/\/[^\s<"]+)(?![^<]*<\/a>)/g;
      content = content.replace(urlRegex, (url) => {
        return `<a href="${url}" target="_blank" class="text-primary underline cursor-pointer">${url}</a>`;
      });
      
      return content;
    }
  }
}
</script>

<style lang="scss" scoped></style>